// Module
var code = "<md-nav-bar class=\"main-nav\" md-selected-nav-item=\"$ctrl.currentNavItem\" nav-bar-aria-label=\"Nawigacja\"> <md-nav-item ng-repeat=\"item in $ctrl.items\" md-nav-sref=\"{{item.state || false}}\" name=\"{{item.state || false}}\"> {{::item.title}} </md-nav-item> </md-nav-bar> ";
// Exports
export default code;